<template>
  <SettingPanel title="SLA timeout" :loading="isLoading">
    <template #edit="{ done }">
      <SlaManagement :setting="data" @updateSetting="data = $event" @onClose="done()" />
    </template>

    {{ data.ticket_agent_sla_time }} Sec
  </SettingPanel>
</template>

<script>
import SettingPanel from './SettingPanel.vue'
import SlaManagement from './SlaManagement.vue'
import ticket3PageApi from '@/api/ticket3/page'
import { handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'

export default {
  components: { SettingPanel, SlaManagement },
  data() {
    return {
      data: {
        ticket_agent_sla_time: 30
      },
      isLoading: true
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  created() {
    this.handleGetSlaTime()
  },
  methods: {
    async handleGetSlaTime() {
      try {
        this.isLoading = true

        const response = await ticket3PageApi.getSlaTime({
          params: {
            page_id: this.selectedBot.pageid
          }
        })

        if (response.status === 200) {
          this.data = response.data
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/SlaTimeout.vue